export const FilterIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.383 3.403l6.588 7.674a.628.628 0 01.154.407v4.661a.31.31 0 00.21.297l3.131 1.042a.31.31 0 00.409-.297v-5.703a.628.628 0 01.156-.407l6.586-7.674a.547.547 0 00-.414-.903H1.799a.547.547 0 00-.416.903z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
